<style scoped>
.is-invalid {
  border-bottom: 1px solid #dc3545 !important;
  border-radius: 0;
}

.is-invalid-popup {
  border: 1px solid #dc3545 !important;
}

.action-tab-select-down {
  text-align: left;
}

.workflow-map-fields {
  width: 100% !important;
}

.map-fields-name {
  width: 100% !important;
}

.action-dropdown-toggle {
  background: none;
  border: none;
  font-weight: 400;
  color: #00a8ff;
  padding: 2px;
  font-size: 12px;
}

.map-fields-name-action {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
}

.map-fields-name-action sup {
  color: #ff0000;
  font-size: 14px !important;
}

.map-fields-name-action-input {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
  margin-top: 16px;
}

.map-fields-name-action-input sup {
  color: #ff0000;
  font-size: 14px !important;
}

.workflow-map-fields-items a:after {
  content: none;
}

.action-tab-select-down-menu ul li a {
  margin-left: 0;
  padding-left: 10px;
}

.action-tab-select-down-menu {
  width: 200px;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

.secondary-create-record-section {
  border-top: 1px solid #e3e7ea;
  margin-top: 12px;
  padding-top: 14px;
}

.secondary-create-record-section .workflow-crete-set-field {
  margin-top: 0;
}

.secondary-map-fields-wrap {
  padding-top: 6px;
}

/* Left-align the "Table" selector (primary + secondary) with the section
   content instead of inheriting the centered/indented header layout. */
.workflow-tab-select-table {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  padding: 0 25px;
  margin-left: 0;
  margin-top: 10px;
}

.workflow-tab-select-table > p {
  margin: 0;
}

/* The secondary selector already sits inside the 25px-padded fields container,
   so drop its own horizontal padding to line up with the section content. */
.workflow-tab-select-table.secondary-tab-select-table {
  padding-left: 0;
  padding-right: 0;
}

.wf-task-tab-content a:after {
  content: none;
}

.send-mail-inputs {
  margin-top: 0;
  height: auto;
  padding: 2px 0px;
  width: 100% !important;
}

.field-input {
  height: 35px !important;
  min-height: 35px !important;
}

.auto-schedule-select-date-end {
  margin-bottom: 12px;
}

.workflow-accordion-container-modify {
  overflow-y: auto;
  padding: 0 14px 10px 14px;
  position: relative;
  height: 330px;
  min-height: 330px;
}

.workflow-accordion-container-modify-record {
  overflow-y: auto;
  padding: 0 14px 10px 14px;
  position: relative;
  min-height: 330px;
}

.popup-container {
  min-height: 300px;
}

.content-error {
  font-size: 12px;
  color: red;
}

.close-custom {
  top: 50%;
  right: 0;
  font-size: 15px;
  transform: translateY(-50%);
}

.error-action-creation {
  color: red !important;
  font-size: 14px !important;
}

#automated-section .full-width-dialog {
  min-width: 60% !important;
  height: 92vh;
}

#automated-section .workflow-map-fields-container {
  padding: 25px;
  height: calc(100% - 237px);
  overflow-y: auto;
}

#automated-section .automation_template_editor {
  height: calc(100vh - 350px);
}

.item-detail {
  margin-top: 12px;
}

#automated-section .task-action-container .popup-search-filter-items {
  padding: 1px;
}

#automated-section .task-action-container .popup-search-filter-items ul {
  margin-bottom: 0px;
}

#automated-section .task-action-container .popup-search-filter-items ul a {
  width: 100%;
}

#automated-section .vtask-txtbx {
  margin-left: 15px;
  width: 255px;
}

#automated-section .task-action-container .test-query-input {
  margin-left: 15px;
  width: 255px;
}
</style>

<template>
  <!-- Modal -->
  <div class="modal fade automation_action_modal_main" id="add-action-modal" tabindex="-1" role="dialog"
       aria-labelledby="actionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg full-width-dialog" role="document">
      <div class="modal-content automation_action_modal_content">
        <div class="modal-body workflow-modal-body">
          <div class="border-body-right-top"></div>
          <div class="workfloww-tab-main-container">
            <span>{{ lang.most_common }}</span>
            <ul class="nav nav-tabs workflow-modal-nav" id="myTab" role="tablist">
              <!-- Create Record Tab Link / Sidebar -->
              <li class="nav-item">
                <a class="nav-link active" id="add-create-record-tab" data-toggle="tab"
                   href="#add-create-record"
                   role="tab" aria-controls="add-create-record" aria-selected="true">
                  <img :src="url+'/create-record.svg'">
                  {{ lang.create_record }} &nbsp;
                  <i class="fa fa-exclamation-circle fa-lg text-danger"
                     id="add-create-record-has-required" style="display: none;">
                  </i>
                </a>
              </li>
              <!-- Modify Record Tab Link / Sidebar -->
              <li class="nav-item">
                <a class="nav-link" id="add-modify-record-tab" data-toggle="tab"
                   href="#add-modify-record" role="tab"
                   aria-controls="add-modify-record" aria-selected="false">
                  <img :src="url+'/modify-record.svg'">
                  {{ lang.modify_record }} &nbsp;
                  <i class="fa fa-exclamation-circle fa-lg text-danger"
                     id="add-modify-record-has-required" style="display: none;">
                  </i>
                </a>
              </li>
              <!-- Create Task Tab Link / Sidebar -->
              <!-- Remove display none if you want to show create task tab -->
              <li class="nav-item">
                <a class="nav-link" id="add-create-task-tab" data-toggle="tab" href="#add-create-task"
                   role="tab"
                   aria-controls="add-create-task" aria-selected="false">
                  <img :src="url+'/create-task.svg'">
                  {{ lang.create_task }} &nbsp;
                  <i class="fa fa-exclamation-circle fa-lg text-danger"
                     id="add-task-record-has-required" style="display: none;">
                  </i>
                </a>
              </li>
              <!-- Send Email Tab Link / Sidebar -->
              <li class="nav-item">
                <a class="nav-link" id="add-send-email-tab" data-toggle="tab" href="#add-send-email"
                   role="tab"
                   aria-controls="add-send-email" aria-selected="false">
                  <img :src="url+'/send-email.svg'">
                  {{ lang.send_email }} &nbsp;
                  <i class="fa fa-exclamation-circle fa-lg text-danger"
                     id="add-send-email-record-has-required" style="display: none;">
                  </i>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content workflow-modal-content" id="myTabContent">

            <!-- Add Create Record Tab Content -->
            <div class="tab-pane fade show active" id="add-create-record" role="tabpanel"
                 aria-labelledby="add-create-record-tab">
              <div class="workflow-create-header">
                <h2>{{ lang.create_record }}</h2>
              </div>
              <div class="workflow-tab-content">
                <div class="workflow-crete-set-field">
                  <h2>{{ lang.hint_one_create_record }}</h2>
                  <p>{{ lang.hint_two }}</p>
                </div>
              </div>
              <div class="workflow-tab-select-table">
                <p>{{ lang.table }}</p>
                <div class="dropdown workflow-tab-select-down">
                  <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ DropDownSelectedTable_Create.label }}
                  </button>
                  <div class="dropdown-menu workflow-tab-select-down-menu"
                       aria-labelledby="dropdownMenuButton">
                    <div class="popup-search-filter">
                      <input class="form-control table-filter-row-search"
                             v-on:keyup="searchSubmit($event)"
                             type="Search" :placeholder="lang.search+'..'">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                    <div class="popup-search-filter-items" id="filterSearchModal">
                      <p>{{ lang.select_table }}</p>
                      <ul>
                        <li v-for="table in OtherTables" @click="SelectTableCreate(table)"><a
                            href="javascript:void(0)">{{
                            table.label
                          }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="MapFieldsCreate != null" class="workflow-map-fields-container">
                <p class="workflow-map-fields-title">{{ lang.map_fields }}</p>
                <div class="workflow-map-fields">
                  <div v-for="field in MapFieldsCreate" v-if="field.field_type != 'autonumber'"
                       class="workflow-map-fields-items">
                    <div class="row">
                      <div class="col-md-3 d-flex justify-content-end"
                           :class="fieldTypeOf(field) ? 'align-items-center' : ''">
                        <div class="map-fields-name-action">
                          {{ field.label }} <sup v-if="field.is_required">*</sup>
                        </div>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down" v-if="fieldTypeOf(field)">
                          <input
                              class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                              v-bind:id="'mapFieldModifyDD-'+field.id"
                              type="button"
                              v-on:click.stop.prevent="openCreateAccordion(field.label)"
                              v-bind:value="selectedValues[field.id]"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-bind:class="{ 'is-invalid-popup': create_record_error[field.name] == true  }"
                          />
                        </div>
                        <button class="close close-custom position-absolute"
                                v-if="hasSelectedData(CreateRecordMapping,field) && fieldTypeOf(field)"
                                @click="removeSelectedItem(CreateRecordMapping,field)">
                          <i class="fa fa-times"></i>
                        </button>
                        <div v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                          <div class="popup-container-main" v-if="checkDD_Create(field.label)"
                               :id="'popup-container-main-'+level" style="left: 0;top: 100%;"
                               v-click-outside="outside_create">
                            <div class="popup-container popup-container-modify">
                              <div class="popup-search-filter">
                                <div class="workflow-selected-field">
                                  <span>{{ lang.select + ' ' + lang.value }}</span>
                                </div>
                              </div>
                              <div
                                  class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                <AccordionForCreateRecord
                                    :level="level"
                                    :table="SelectedTable.label"
                                    :fields="SelectedTable.fields"
                                    :users="UserTable"
                                    :lang="lang"
                                    :mapping_for="field"
                                    :custom="true"
                                    :field_type="field.field_type"
                                    v-on:CreateRecordOptionSelectedEvent="CreateRecordOptionSelected"
                                    :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListReationship"
                                    :CreateRecordMapping="CreateRecordMapping"
                                    :executeHandler="executeHandler"
                                ></AccordionForCreateRecord>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <dateTimePickerCreateRecord
                              :level="level"
                              :Auth="Auth"
                              :lang="lang"
                              :locale="lang.code"
                              :mapping_for="field"
                              :custom="true"
                              :button-now-translation="lang.now"
                              :field_type="field.field_type"
                              :type="field.type"
                              :actionType="'create_record'"
                              :fields="SelectedTable.fields"
                              :table="SelectedTable.label"
                              v-on:CreateRecordOptionSelectedEvent="CreateRecordOptionSelected"
                              v-on:removeSelectedItemEvent="removeSelectedItem(CreateRecordMapping, field)"
                              :CreateRecordMapping="CreateRecordMapping"
                              v-bind:class="{ 'is-invalid-popup': create_record_error[field.name] == true  }"
                          ></dateTimePickerCreateRecord>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              <!-- Secondary "create another record" section -->
              <div class="workflow-tab-content secondary-create-record-section" v-if="MapFieldsCreate != null">
                <div class="workflow-crete-set-field">
                  <label class="d-flex align-items-center" style="gap:8px; margin:0; cursor:pointer;">
                    <input type="checkbox" v-model="showSecondaryCreate" @change="onToggleSecondaryCreate"/>
                    <span>{{ lang.create_another_record }}</span>
                  </label>
                </div>
                <p v-if="showSecondaryCreate">{{ lang.create_another_record_hint }}</p>
              </div>

              <template v-if="showSecondaryCreate && DropDownSelectedTable_Create && DropDownSelectedTable_Create.id">
                <div class="workflow-tab-select-table secondary-tab-select-table">
                  <p>{{ lang.table }}</p>
                  <div class="dropdown workflow-tab-select-down">
                    <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button"
                            id="dropdownMenuButtonSecondaryCreate" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                      {{ SecondaryCreateTable_label }}
                    </button>
                    <div class="dropdown-menu workflow-tab-select-down-menu"
                         aria-labelledby="dropdownMenuButtonSecondaryCreate">
                      <div class="popup-search-filter">
                        <input class="form-control table-filter-row-search"
                               v-on:keyup="searchSubmitSecondaryCreate($event)" type="Search"
                               :placeholder="lang.search+'..'">
                        <i class="fa fa-search" aria-hidden="true"></i>
                      </div>
                      <div class="popup-search-filter-items" id="filterSearchModalSecondaryCreate">
                        <p>{{ lang.select_table }}</p>
                        <ul>
                          <li v-for="table in SecondaryCreateTableOptions" :key="table.id"
                              @click="SelectSecondaryCreateTable(table)">
                            <a href="javascript:void(0)">{{ table.label }}</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="SecondaryCreateTable && SecondaryCreateTable.fields" class="secondary-map-fields-wrap">
                  <p class="workflow-map-fields-title">
                    {{ lang.map_fields }}
                    <small v-if="DropDownSelectedTable_Create.label">&mdash; {{ DropDownSelectedTable_Create.label }}</small>
                  </p>
                  <div class="workflow-map-fields">
                    <div v-for="field in SecondaryCreateTable.fields" v-if="field.field_type != 'autonumber'"
                         :key="field.id" class="workflow-map-fields-items">
                      <div class="row">
                        <div class="col-md-3 d-flex justify-content-end"
                             :class="fieldTypeOf(field) ? 'align-items-center' : ''">
                          <div class="map-fields-name-action">
                            {{ field.label }} <sup v-if="field.is_required">*</sup>
                          </div>
                        </div>
                        <div class="col-auto d-flex align-items-center">
                          <div class="dropdown action-tab-select-down" v-if="fieldTypeOf(field)">
                            <input
                                class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                type="button"
                                v-on:click.stop.prevent="openSecondaryCreateAccordion(field.label)"
                                v-bind:value="secondaryCreateSelectedValues[field.id]"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            />
                          </div>
                          <button class="close close-custom position-absolute"
                                  v-if="hasSelectedData(SecondaryCreateMapping,field) && fieldTypeOf(field)"
                                  @click="removeSecondaryCreateSelectedItem(SecondaryCreateMapping,field)">
                            <i class="fa fa-times"></i>
                          </button>
                          <div v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                            <div class="popup-container-main" v-if="checkDD_SecondaryCreate(field.label)"
                                 :id="'popup-container-secondary-create-'+level" style="left: 0;top: 100%;"
                                 v-click-outside="outside_secondary_create">
                              <div class="popup-container popup-container-modify">
                                <div class="popup-search-filter">
                                  <div class="workflow-selected-field">
                                    <span>{{ lang.select + ' ' + lang.value }}</span>
                                  </div>
                                </div>
                                <div class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                  <AccordionForCreateRecord
                                      :level="level"
                                      :table="DropDownSelectedTable_Create.label"
                                      :fields="DropDownSelectedTable_Create.fields"
                                      :users="UserTable"
                                      :lang="lang"
                                      :mapping_for="field"
                                      :custom="true"
                                      :field_type="field.field_type"
                                      v-on:CreateRecordOptionSelectedEvent="SecondaryCreateOptionSelected"
                                      :SelectedTableExcludedColumnList="SecondaryCreateSourceExcluded"
                                      :sourceTable="SelectedTable.label"
                                      :sourceFields="SelectedTable.fields"
                                      :sourceExcludedColumnList="SelectedTableExcludedColumnListReationship"
                                      :CreateRecordMapping="SecondaryCreateMapping"
                                      :executeHandler="1"
                                  ></AccordionForCreateRecord>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <dateTimePickerCreateRecord
                                :level="level"
                                :Auth="Auth"
                                :lang="lang"
                                :locale="lang.code"
                                :mapping_for="field"
                                :custom="true"
                                :button-now-translation="lang.now"
                                :field_type="field.field_type"
                                :type="field.type"
                                :actionType="'create_record'"
                                :fields="DropDownSelectedTable_Create.fields"
                                :table="DropDownSelectedTable_Create.label"
                                :showOldRecord="false"
                                :sourceFields="SelectedTable.fields"
                                :sourceTable="SelectedTable.label"
                                v-on:CreateRecordOptionSelectedEvent="SecondaryCreateOptionSelected"
                                v-on:removeSelectedItemEvent="removeSecondaryCreateSelectedItem(SecondaryCreateMapping, field)"
                                :CreateRecordMapping="SecondaryCreateMapping"
                            ></dateTimePickerCreateRecord>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              </div>
            </div>

            <!-- Modify Record Tab Content -->
            <div class="tab-pane fade" id="add-modify-record" role="tabpanel"
                 aria-labelledby="add-modify-record-tab">
              <div class="workflow-modify-header">
                <h2>{{ lang.modify_record }}</h2>
              </div>
              <div class="workflow-tab-content">
                <div class="workflow-crete-set-field">
                  <h2>{{ lang.hint_one_modify_record }}</h2>
                  <p>{{ lang.hint_two }}</p>
                </div>
              </div>
              <div class="workflow-tab-select-table">
                <p>{{ lang.table }}</p>
                <div class="dropdown workflow-tab-select-down">
                  <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ SelectedTable.label }}
                  </button>
                  <div class="dropdown-menu workflow-tab-select-down-menu"
                       aria-labelledby="dropdownMenuButton">
                    <div class="popup-search-filter">
                      <input class="form-control table-filter-row-search" type="Search"
                             :placeholder="lang.search+'..'">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                    <div class="popup-search-filter-items">
                      <p>{{ lang.select + ' ' + lang.record }}</p>
                      <ul>
                        <li @click="SelectTableModify()"><a
                            href="javascript:void(0)">{{ SelectedTable.label }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="SelectedTable.fields != null" class="workflow-map-fields-container">
                <p class="workflow-map-fields-title">{{ lang.map_fields }} </p>
                <div class="workflow-map-fields">
                  <div v-for="field in SelectedTable.fields" v-if="field.field_type != 'autonumber'"
                       class="workflow-map-fields-items">
                    <div class="row">
                      <div class="col-md-3 d-flex justify-content-end"
                           :class="fieldTypeOf(field) ? 'align-items-center' : ''">
                        <div class="map-fields-name-action">
                          {{ field.label }} <sup v-if="field.is_required">*</sup>
                        </div>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down" v-if="fieldTypeOf(field)">
                          <input
                              class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                              v-bind:id="'mapFieldModifyDD-'+field.id"
                              type="button"
                              v-on:click.stop.prevent="openModifyAccordion(field.label)"
                              v-bind:value="InitLabelForModify(field)"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-bind:class="{ 'is-invalid-popup': modify_record_error[field.name] == true  }"
                          />
                        </div>
                        <button class="close close-custom position-absolute"
                                v-if="hasSelectedData(ModifyRecordMapping,field) && fieldTypeOf(field)"
                                @click="removeSelectedItem(ModifyRecordMapping,field)">
                          <i class="fa fa-times"></i>
                        </button>
                        <div v-if="fieldTypeOf(field)">
                          <div class="popup-container-main" v-if="checkDD_Modify(field.label)"
                               :id="'popup-container-main-'+level" style="left: 0;top: 100%;"
                               v-click-outside="outside_modify">
                            <div class="popup-container popup-container-modify">
                              <div class="popup-search-filter">
                                <div class="workflow-selected-field">
                                  <span>{{ lang.select + ' ' + lang.value }}</span>
                                </div>
                              </div>
                              <div class="workflow-accordion-container-modify-record">
                                <AccordionForModifyRecord
                                    :level="level"
                                    :table="SelectedTable.label"
                                    :fields="SelectedTable.fields"
                                    :users="UserTable"
                                    :mapping_for="field"
                                    :custom="true"
                                    :lang="lang"
                                    :field_type="field.field_type"
                                    v-on:ModifyRecordOptionSelectedEvent="ModifyRecordOptionSelected"
                                    :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListReationship"
                                    :ModifyRecordMapping="ModifyRecordMapping"
                                    :modify_record_error="modify_record_error"
                                    :executeHandler="executeHandler"
                                ></AccordionForModifyRecord>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <dateTimePickerModifyRecord
                              :level="level"
                              :Auth="Auth"
                              :lang="lang"
                              :locale="lang.code"
                              :button-now-translation="lang.now"
                              :mapping_for="field"
                              :custom="true"
                              :field_type="field.field_type"
                              :type="field.type"
                              :actionType="'modify_record'"
                              v-on:ModifyRecordOptionSelectedEvent="ModifyRecordOptionSelected"
                              v-on:removeSelectedItemEvent="removeSelectedItem(ModifyRecordMapping, field)"
                              :ModifyRecordMapping="ModifyRecordMapping"
                              v-bind:class="{ 'is-invalid-popup': modify_record_error[field.name] == true  }"
                          ></dateTimePickerModifyRecord>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Create Task Tab Content -->
            <div class="tab-pane fade" id="add-create-task" role="tabpanel"
                 aria-labelledby="add-create-task-tab">
              <div class="workflow-task-header">
                <h2>{{ lang.create_task }}</h2>
              </div>
              <form>
                <div class="wf-task-tab-container task-action-container">
                  <div v-if="TaskTable" v-for="field in TaskTable" class="wf-task-tab-content">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="map-fields-name-action-input">
                          {{ field.label }} <sup v-if="field.is_required">*</sup>
                        </div>
                      </div>

                      <!-- related field -->
                      <div v-if="field.field_type == 'relationship'" class="item-detail">
                        <div class="col-auto d-flex align-items-center">
                          <div class="dropdown action-tab-select-down">
                            <input
                                class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                v-bind:id="'mapFieldTaskDD-'+field.name"
                                type="button"
                                v-on:click.stop.prevent="openTaskAccordion(field.label)"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                v-bind:value="InitLabelForTask(field)"
                            />
                            <div
                                v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                              <div class="popup-container-main"
                                   v-if="checkDD_Task(field.label)"
                                   :id="'popup-container-main-'+level"
                                   style="left: 0;top: 100%;"
                                   v-click-outside="outside_task">
                                <div class="popup-container popup-container-modify">
                                  <div class="popup-search-filter">
                                    <div class="workflow-selected-field">
                                                                            <span>{{
                                                                                lang.select + ' ' + lang.value
                                                                              }}</span>
                                    </div>
                                  </div>
                                  <div
                                      class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                    <AccordionForCreateRecord
                                        :level="level"
                                        :table="SelectedTable.label"
                                        :fields="SelectedTable.fields"
                                        :users="UserTable"
                                        :lang="lang"
                                        :mapping_for="field"
                                        :custom="true"
                                        :field_type="field.field_type"
                                        v-on:CreateRecordOptionSelectedEvent="TaskRecordOptionSelected"
                                        :SelectedTableExcludedColumnList="RemoveIDValueForTaskAccordion(SelectedTableExcludedColumnListReationship)"
                                        :CreateRecordMapping="CreateRecordMapping"
                                        :executeHandler="executeHandler"
                                    ></AccordionForCreateRecord>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="dropdown-menu action-tab-select-down-menu" style="padding: 0px;" aria-labelledby="dropdownMenuButton">
                                <div class="popup-search-filter-items">
                                    <ul>
                                        <li v-for="(field_dd, index) in field.related_fields" @click="SelectMapField('task', field.name, { name: field_dd, id:index })" ><a href="javascript:void(0)">{{ field_dd }}</a></li>
                                    </ul>
                                </div>
                            </div> -->
                          </div>
                          <button class="close close-custom position-absolute"
                                  @click="removeSelectedValue(field.name)"
                                  v-if="hasValueSelectedTask(field.name)">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <!-- dropdown -->
                      <div v-else-if="field.field_type == 'select'" class="item-detail">
                        <div class="col-auto d-flex align-items-center">
                          <div class="dropdown action-tab-select-down">
                            <input
                                class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                v-bind:id="'mapFieldTaskDD-'+field.name" type="button"
                                :value="lang.select+' '+lang.value" data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"/>
                            <div class="dropdown-menu action-tab-select-down-menu"
                                 style="padding: 0px;"
                                 aria-labelledby="dropdownMenuButton">
                              <div class="popup-search-filter-items">
                                <ul>
                                  <li v-for="field_dd in field.select_values"
                                      @click="SelectMapField('task', field.name, field_dd)">
                                    <a
                                        href="javascript:void(0)">{{ field_dd }}</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <button class="close close-custom position-absolute"
                                  @click="removeSelectedValue(field.name)"
                                  v-if="hasValueSelectedTask(field.name)">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <!-- Other types -->
                      <div v-else>
                        <div
                            v-if="field.name == 'created_by' || field.name == 'modified_by' || field.name == 'assigned_to'"
                            class="item-detail">
                          <div class="col-auto d-flex align-items-center">
                            <div class="dropdown action-tab-select-down">
                              <input
                                  class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                  v-bind:id="'mapFieldTaskDD-'+field.name"
                                  type="button"
                                  v-on:click.stop.prevent="openTaskAccordion(field.label)"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  v-bind:value="InitLabelForTask(field)"
                              />
                              <div
                                  v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                                <div class="popup-container-main"
                                     v-if="checkDD_Task(field.label)"
                                     :id="'popup-container-main-'+level"
                                     style="left: 0;top: 100%;"
                                     v-click-outside="outside_task">
                                  <div class="popup-container popup-container-modify">
                                    <div class="popup-search-filter">
                                      <div class="workflow-selected-field">
                                                                                <span>{{
                                                                                    lang.select + ' ' + lang.value
                                                                                  }}</span>
                                      </div>
                                    </div>
                                    <div
                                        class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                      <AccordionForCreateRecord
                                          :level="level"
                                          :table="SelectedTable.label"
                                          :fields="SelectedTable.fields"
                                          :users="UserTable"
                                          :lang="lang"
                                          :mapping_for="field"
                                          :custom="false"
                                          :field_type="field.field_type"
                                          v-on:CreateRecordOptionSelectedEvent="TaskRecordOptionSelected"
                                          :SelectedTableExcludedColumnList="RemoveIDValueForTaskAccordion(SelectedTableExcludedColumnListReationship)"
                                          :CreateRecordMapping="CreateRecordMapping"
                                          :executeHandler="executeHandler"
                                      ></AccordionForCreateRecord>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button class="close close-custom position-absolute"
                                    @click="removeSelectedValue(field.name)"
                                    v-if="hasValueSelectedTask(field.name)">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        </div>
                        <div v-else-if="field.type == 'date' || field.type == 'datetime'">
                          <div class="position-relative test-query-input">
                            <VueCtkDateTimePicker
                                :format="setDynamicFormat()+' HH:mm'"
                                :formatted="setDynamicFormat()+' HH:mm'"
                                v-model="create_task[field.name]"
                                :no-label="true"
                                :noClearButton="true"
                                :locale="lang.code"
                                :button-now-translation="lang.now"
                                label=""
                                :position="'bottom'"
                            />
                          </div>
                        </div>
                        <div v-else>
                          <input type="text"
                                 @input="SelectMapField('task', field.name, $event.target.value)"
                                 v-model="create_task[field.name]" :ref="field.name"
                                 :id="field.name"
                                 class="test-query-field vtask-txtbx">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- Send Email Tab Content -->
            <div class="tab-pane fade" id="add-send-email" role="tabpanel"
                 aria-labelledby="add-send-email-tab">
              <div class="workflow-email-header">
                <h2>{{ lang.send_email }}</h2>
                <div class="wf-tab-email-main-container">
                  <form enctype="multipart/form-data">
                    <div class="wf-task-tab-container">
                      <div class="wf-task-tab-content wf-task-anchor">

                        <div class="row">
                          <div class="col-md-3">
                            <div class="map-fields-name-action">{{ lang.from }}<sup>*</sup>
                            </div>
                          </div>
                          <div class="col-auto d-flex align-items-center">
                            <div class="dropdown action-tab-select-down">
                              <input
                                  class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                  v-bind:id="'mapFieldEmailDD-'+'from'"
                                  v-bind:class="{ 'is-invalid-popup': send_email_error.from == true  }"
                                  type="button"
                                  v-on:click.stop.prevent="modifyAccordion('from')"
                                  :value="lang.select+' '+lang.value"
                                  data-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false"/>
                              <div class="popup-container-main"
                                   v-if="checkActiveDD('from')"
                                   :id="'popup-container-main-'+level">
                                <div class="popup-container popup-container-modify">
                                  <div class="popup-search-filter">
                                    <div class="workflow-selected-field">
                                                                            <span>{{
                                                                                lang.select + ' ' + lang.field
                                                                              }}</span>
                                    </div>
                                  </div>
                                  <div class="workflow-accordion-container-modify"
                                       v-click-outside="outside">
                                    <AccordionForSendMail
                                        :field-id="'from'"
                                        :SelectedTableExcludedColumnList="emilFrom(SelectedTableExcludedColumnListEmail)"
                                        :SelectedTableLabel="SelectedTable.label"
                                        :level="level"
                                        :lang="lang"
                                        :custom="false"
                                        v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                        :fields="UserTable"
                                        :executeHandler="executeHandler"
                                    ></AccordionForSendMail>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button class="close close-custom position-absolute"
                                    v-if="hasSelectedDataEmailTask(send_email,'from')"
                                    v-on:click.stop.prevent="removeSelectedItemEmail(send_email,'from')">
                              <i class="fa fa-times"></i>
                            </button>

                          </div>
                        </div>

                      </div>
                      <div class="wf-task-tab-content wf-task-anchor">

                        <div class="row">
                          <div class="col-md-3">
                            <div class="map-fields-name-action">{{
                                lang.recipient
                              }}<sup>*</sup></div>
                          </div>
                          <div class="col-auto d-flex align-items-center">
                            <div class="dropdown action-tab-select-down">
                              <input
                                  class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                  v-bind:id="'mapFieldEmailDD-'+'recipient'"
                                  v-bind:class="{ 'is-invalid-popup': send_email_error.recipient == true  }"
                                  type="button"
                                  v-on:click.stop.prevent="modifyAccordion('to')"
                                  :value="lang.select+' '+lang.value"
                                  data-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false"/>
                              <div class="popup-container-main" v-if="checkActiveDD('to')"
                                   :id="'popup-container-main-'+level">
                                <div class="popup-container popup-container-modify">
                                  <div class="popup-search-filter">
                                    <div class="workflow-selected-field">
                                                                            <span>{{
                                                                                lang.select + ' ' + lang.field
                                                                              }}</span>
                                    </div>
                                  </div>
                                  <div class="workflow-accordion-container-modify"
                                       v-click-outside="outside">
                                    <AccordionForSendMail
                                        :field-id="'recipient'"
                                        :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListEmail"
                                        :SelectedTableLabel="SelectedTable.label"
                                        :level="level"
                                        v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                        :lang="lang"
                                        :custom="true"
                                        :fields="UserTable"
                                        :executeHandler="executeHandler"
                                    ></AccordionForSendMail>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button class="close close-custom position-absolute"
                                    v-if="hasSelectedDataEmailTask(send_email,'recipient')"
                                    v-on:click.stop.prevent="removeSelectedItemEmail(send_email,'recipient')">
                              <i class="fa fa-times"></i>
                            </button>

                          </div>
                        </div>
                      </div>

                      <div class="wf-task-tab-content wf-task-anchor">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="map-fields-name-action">{{ lang.cc }}</div>
                          </div>
                          <div class="col-auto d-flex align-items-center">
                            <div class="dropdown action-tab-select-down">
                              <input
                                  class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                  v-bind:id="'mapFieldEmailDD-cc'"
                                  v-bind:class="{ 'is-invalid-popup': send_email_error.cc == true  }"
                                  v-on:click.stop.prevent="modifyAccordion('cc')"
                                  type="button"
                                  :value="lang.select+' '+lang.value"
                                  data-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false"/>
                              <div class="popup-container-main" v-if="checkActiveDD('cc')"
                                   :id="'popup-container-main-'+level">
                                <div class="popup-container popup-container-modify">
                                  <div class="popup-search-filter">
                                    <div class="workflow-selected-field">
                                      <span>{{ lang.select + ' ' + lang.field }}</span>
                                    </div>
                                  </div>
                                  <div class="workflow-accordion-container-modify"
                                       v-click-outside="outside">
                                    <AccordionForSendMail
                                        :field-id="'cc'"
                                        :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListEmail"
                                        :SelectedTableLabel="SelectedTable.label"
                                        :level="level"
                                        v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                        :lang="lang"
                                        :custom="true"
                                        :fields="UserTable"
                                        :executeHandler="executeHandler"
                                    ></AccordionForSendMail>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                                class="close close-custom position-absolute"
                                v-if="hasSelectedDataEmailTask(send_email,'cc')"
                                v-on:click.stop.prevent="removeSelectedItemEmail(send_email,'cc')"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="wf-task-tab-content">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="map-fields-name-action">{{
                                lang.subject
                              }}<sup>*</sup></div>
                          </div>
                          <div class="col-md-9">
                            <input type="text" v-model="send_email.subject"
                                   v-bind:class="{ 'is-invalid': send_email_error.subject == true  }"
                                   name="task"
                                   class="wf-task-input send-mail-inputs"
                                   :placeholder="lang.enter +' '+ lang.subject">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 editor-col automation_template_editor">
                          <editor
                              api-key="ark2od11b4yseas05mfof68fjpjte4ambcy2pfj5ikmu8fwh"
                              v-model="send_email.content"
                              :init="init"
                              :id="'automation-email-action-'"
                          ></editor>
                          <div v-if="send_email_error.content">
                            <p class="content-error"> *Content can not be empty!</p>
                          </div>


                          <div v-show="showDropZone" class="form-group mt-9">
                            <div class="pt-2 display-attachments-automation">Email
                              Attachments
                            </div>
                            <vue-dropzone
                                id="customdropzone-temp"
                                class='custom_dzone'
                                ref="dropzone"
                                :options="dropOptions"
                                @vdropzone-file-added="fileAdded"
                                @vdropzone-removed-file="removeFile"
                            ></vue-dropzone>
                          </div>

                          <div class="pt-1" v-if="renderingPdfList.length > 0">
                            PDF Attachments
                          </div>
                          <div class="display-pdfs-automation">
                            <div v-for="pdf in renderingPdfList" class="pl-2">
                              {{ pdf.name + `.pdf` }}
                              <i class="fa fa-times ml-2" @click="removePdf(pdf.id)"
                                 style="cursor: pointer"
                                 data-dz-remove></i>
                            </div>
                          </div>


                          <div class="pt-1"
                               v-if="xmlList.length">
                            XML Attachments
                          </div>
                          <div class="display-pdfs-automation">
                            <div v-for="(xml, index) in xmlList" class="pl-2">
                              {{ xml.template.name }} <span v-if="xml.filter"> ({{ xml.filter.name }}) </span>
                              <i class="fa fa-times ml-2" @click="removeXML(index)" style="cursor: pointer"
                                 data-dz-remove></i>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default wf-modal-cancel" data-dismiss="modal">{{
              lang.cancel
            }}
          </button>
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="SaveAction()">{{
              lang.save
            }}
          </button>
        </div>
      </div>
    </div>

    <EmailPDFModal
        :templateList="TemplateList"
        :selectedPdfList="selectedPdfList"
        :modalId="level+'-temp'"
        v-if="showPdfModal"
        v-on:pdflistchangedEvent="selectedPdfs"
    />

    <AttachXMLModal
        v-if="SelectedTableId"
        :table="SelectedTableId"
        :modalId="level+'-temp'"
        v-on:addXMLFilterEvent="addXMLFilterForAction"
    />

    <div class="modal fade" id="record-placeholder-modal" tabindex="-1" role="dialog"
         aria-labelledby="record-placeholder-modal"
         aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="relation-title">Choose Fields</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="placeholder-body">
            <div class="fields">
              <div class="mt-1 mb-2 ml-1"><b>Select Columns</b></div>
              <select id="record-picker" class="form-control picker d-inline-block" multiple
                      v-model="selected_record_fields">
                <option :value="field.name" v-for="field in this.SelectedTable.fields">
                  {{ field.label }}
                </option>
                <option value="@record_url">Record URL</option>
              </select>
            </div>

            <div class="row mt-3 record-holder-options">
              <div class="col-12">
                <div><b>Group Record By</b></div>
                <select id="record-group-by" class="form-control d-inline-block" v-model="group_by_field">
                  <option value="">Select Field</option>
                  <option :value="field.name" v-for="field in this.SelectedTable.fields">
                    {{ field.label }}
                  </option>
                </select>
              </div>

              <div class="col-12 mt-1">
                <div class="row">
                  <div class="form-group form-check show-field-names">
                    <input type="checkbox" id="show-field-names" v-model="display_fields" true-value="true"
                           false-value="false"> Display Field Names
                  </div>

                  <div class="form-group form-check show-next-line">
                    <input type="checkbox" id="show-next-line" v-model="print_new_line" true-value="true"
                           false-value="false"> Print values on separate line
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button type="button" class="btn btn-primary apply-btn-color m-auto" @click="selectRecordPlaceholder">Add
              Placeholder
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/imagetools';
import Editor from '@tinymce/tinymce-vue';
import dateTimePickerCreateRecord from './dateTimePickerCreateRecord.vue';
import dateTimePickerModifyRecord from './dateTimePickerModifyRecord.vue';
import vueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import EmailPDFModal from '../EmailPDFModal.vue';
import AttachXMLModal from '../AttachXMLModal.vue';

export default {
  name: 'ActionModal',
  props: [
    'SelectedTableId',
    'url',
    'level',
    'categories',
    'whenshould',
    'SelectedTableExcludedColumnListReationship',
    'SelectedTableExcludedColumnListEmail',
    'Auth',
    'lang',
    'TemplateList',
    'SelectedTableExcludedColumnList'
  ],
  components: {
    'editor': Editor,
    vueDropzone,
  },
  data() {
    return {
      showPdfModal: false,
      create_due_date: null,
      fields: null,
      SelectedTable: [],
      selectedValues: [],
      ContactTable: [],
      UserTable: [],
      TaskTable: [],
      ExceptionFieldType: ['date', 'datetime'],
      OtherTables: null,
      DropDownSelectedTable_Modify: {label: this.lang.select_table},
      DropDownSelectedTable_Create: {label: this.lang.select_table},
      executeHandler: null,

      // fields for mapping the values
      MapFieldsModify: null,
      MapFieldsCreate: null,
      templateBtnName: 'Template',

      MapValuesModify: {},
      MapValuesCreate: {},
      MapValuesTask: [],
      MapValuesEmail: [],
      dropOptions: {
        url: "/mail",
        thumbnailWidth: 40, // px
        thumbnailHeight: 40,
        addRemoveLinks: false,
        maxFilesize: 25, // MB
        previewTemplate: this.template(),
        autoProcessQueue: false,
        parallelUploads: 10,
        uploadMultiple: true,
      },

      showDropZone: false,
      selectedPdfList: [],
      xmlList: [],
      renderingPdfList: [],

      init: {
        language_url : `/tinymce/langs/${ $('meta[name="language"]').attr('content') }.js`,
        language: $('meta[name="language"]').attr('content'),
        branding: false,
        selector: '#automation-email-action-',
        height: 347,
        plugins: [
          'link', 'image', 'code', 'preview'
        ],
        disabled: false,
        contextmenu_never_use_native: 'link',
        relative_urls: false,
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
          return url;
        },
        toolbar: 'undo redo | Template | variable | attach_file | Attach_PDFs | AttachXML | image | styleselect | bold italic | alignleft aligncenter alignright alignjustify | table | fontsizeselect',

        setup: (editor) => {
          this.mceEditor = editor;
          /*Email template list*/

          editor.ui.registry.addMenuButton('Template', {
            text: this.templateBtnName,
            fetch: (callback) => {

              var template_items = [];

              for (const _temp in this.TemplateList) {

                if (this.TemplateList[_temp].type == 'email') {

                  var _items = {
                    type: 'menuitem',
                    text: this.TemplateList[_temp].name,
                    onAction: () => {
                      tinyMCE.get('automation-email-action-').setContent('');
                      this.send_email.subject = this.TemplateList[_temp].subject;
                      editor.insertContent(this.TemplateList[_temp].content);
                    }
                  };

                  template_items.push(_items);
                }
              }

              callback(template_items);
            }
          });

          editor.ui.registry.addButton('Attach_PDFs', {
            text: translation.attach_pdfs,
            onAction: () => {

              this.showPdfModal = true;

              this.$nextTick(() => {
                $('#email-pdf-modal-' + this.level + '-temp').draggable({
                  handle: ".modal-header"
                });

                $('#email-pdf-modal-' + this.level + '-temp').modal('show');
              })
            }
          });

          editor.ui.registry.addButton('AttachXML', {
            text: translation.attach_xml,
            onAction: () => {
              this.$nextTick(() => {
                $('#email-xml-modal-' + this.level + '-temp').modal('show');
              })
            }
          });

          /*Email template variable*/

          editor.ui.registry.addMenuButton('variable', {
            text: translation.add_field,
            fetch: (callback) => {

              var field_variables = [];
              var __table = this.SelectedTable;

              for (const _temp in __table.fields) {

                var _variable_items = {
                  type: 'menuitem',
                  text: __table.label + '.' + __table.fields[_temp].label,
                  onAction: () => {
                    editor.insertContent(
                        '${' + __table.fields[_temp].name + '}'
                    );
                  }
                };

                field_variables.push(_variable_items);
              }

              for (const _temp in __table.SelectedTableExcludedColumnListReationship) {

                var _variable_items = {
                  type: 'menuitem',
                  text: __table.label + '.' + __table.SelectedTableExcludedColumnListReationship[_temp].label,
                  onAction: () => {
                    editor.insertContent(
                        '${' + __table.SelectedTableExcludedColumnListReationship[_temp].name + '}'
                    );
                  }
                };

                field_variables.push(_variable_items);
              }

              var _variable_items = {
                type: 'menuitem',
                text: 'Record URL',
                onAction: () => {
                  editor.insertContent(
                      '@record_url'
                  );
                }
              };

              field_variables.push(_variable_items);

              var _variable_items = {
                type: 'menuitem',
                text: 'Record',
                onAction: () => {
                  let $modal = $('#record-placeholder-modal');
                  $('.picker').selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                  });
                  $modal.modal('show');
                }
              };
              field_variables.push(_variable_items);
              callback(field_variables);
            }
          });


          /*Attach file*/

          editor.ui.registry.addButton('attach_file', {
            text: translation.attach_files,
            onAction: () => {
              this.attachFiles(event);
            }
          });
        },
      },
      mceEditor: null,
      selected_record_fields: [],
      group_by_field: "",
      print_new_line: "false",
      display_fields: "false",
      create_record: null,
      modify_record: null,

      // values for task creation
      create_task: {
        assigned_to: null,
        subject: null,
        contact_name: null,
        start_datetime: null,
        end_datetime: null,
        person: null,
        category: null,
        status: null,
        priority: null,
        long_description: null,
      },

      dateTimeModalDetails: {
        create_record: {
          start_datetime: null,
          end_datetime: null,
        },
        modify_record: {
          start_datetime: null,
          end_datetime: null,
        }
      },

      // values for email
      send_email: {
        from: null,
        recipient: null,
        cc: null,
        subject: null,
        content: null,
      },

      // save object
      action_details: {
        create_record: null,
        modify_record: null,
        create_task: null,
        send_email: null
      },

      // Accordion
      ActiveAccordion: [],
      ActiveAccordionCreate: [],
      ActiveAccordionModify: [],
      ActiveAccordionTask: [],
      CreateRecordMapping: [],
      ModifyRecordMapping: [],

      // Secondary "create another record" - a further record created from the primary
      // record, mapped from the primary record's own fields.
      showSecondaryCreate: false,
      SecondaryCreateTable: null,
      SecondaryCreateTable_label: this.lang.select_table,
      SecondaryCreateSourceExcluded: [],
      SecondaryCreateMapping: [],
      ActiveAccordionSecondaryCreate: [],
      secondaryCreateSelectedValues: [],

      create_record_error: null,
      modify_record_error: null,

      // task create validation
      create_task_error: {
        assigned_to: false,
        subject: false,
        contact_name: false,
        start_datetime: false,
        end_datetime: false,
        person: false,
        category: false,
        status: false,
        priority: false,
        long_description: false,
      },
      // send mail validation
      send_email_error: {
        from: false,
        recipient: false,
        cc: false,
        subject: false,
        content: false,
      },

    }
  },
  computed: {
    SecondaryCreateTableOptions() {
      let primaryId = this.DropDownSelectedTable_Create && this.DropDownSelectedTable_Create.id
        ? this.DropDownSelectedTable_Create.id : null;
      return (this.OtherTables || []).filter(t => t.id != primaryId);
    }
  },
  mounted() {
    $(document).on('focusin', function (e) {
      if ($(e.target).closest(".tox-dialog").length) {
        e.stopImmediatePropagation();
      }
    });
  },
  watch: {
    SelectedTableId(newvalue, oldvalue) {
      this.GetSelectedTableData();
      this.GetContactTableData();
      this.GetDataApartFromSelectedTable();
      this.GetTaskTableData();
    },
    level(newvalue, oldvalue) {
      this.level = newvalue;
    },
    whenshould() {
      this.executeHandler = this.whenshould;
    },
  },
  methods: {
    addXMLFilterForAction(filter) {
      this.xmlList.push(filter);
    },
    selectedPdfs(values) {
      this.selectedPdfList = values;
      this.getSelectedPdf(this.selectedPdfList);
    },
    getSelectedPdf(_pdfList) {

      this.renderingPdfList = [];

      for (var pdf in _pdfList) {
        var _index = this.TemplateList.findIndex(x => x.id == _pdfList[pdf]);
        if (_index > -1) {
          this.renderingPdfList.push({
            'name': this.TemplateList[_index].name,
            'id': this.TemplateList[_index].id,
          });
        }
      }
    },
    removePdf(pdf_id) {

      var _index = this.renderingPdfList.findIndex(x => x.id == pdf_id);
      if (_index > -1) {
        this.renderingPdfList.splice(_index, 1);
      }

      var existingPdf = [];

      for (var x in this.renderingPdfList) {
        existingPdf.push(this.renderingPdfList[x].id);
      }

      this.selectedPdfList = existingPdf;
    },
    removeXML(index) {
      this.xmlList.splice(index, 1);
    },
    fileAdded(event) {
      this.showDropZone = true;
    },
    removeFile(event) {
      if (!this.$refs.dropzone.getQueuedFiles().length) {
        this.showDropZone = false;
      }
    },
    attachFiles(event) {
      event.preventDefault();
      $('#customdropzone-temp').click();
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                        <div class="dz-details">
                            <div>
                                <div class="upload-details">
                                    <b><span data-dz-name></span></b>

                                    (<span data-dz-size></span>)

                                    <i class="fa fa-times ml-2" style="cursor: pointer" data-dz-remove></i>
                                </div>

                                <div class="upload-progress">
                                    <span class="dz-progress">
                                        <span class="dz-upload" data-dz-uploadprogress></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="dz-error-message"><span data-dz-errormessage></span></div>
                        <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                        <div class="dz-error-mark"><i class="fa fa-times"></i></div>
                    </div>
                `;
    },

    selectRecordPlaceholder(e) {
      let placeholder = '',
          $modal = $('#record-placeholder-modal');
      if (this.selected_record_fields.length) {
        let options = {
          record_group_by: this.group_by_field,
          show_field_names: this.display_fields,
          show_next_line: this.print_new_line
        };
        placeholder = `@record([[${JSON.stringify(options)}],[${JSON.stringify(this.selected_record_fields)}]])`;
        $modal.modal('hide');
        this.mceEditor.insertContent(placeholder);
      }
    },

    // get the values of the present table
    GetSelectedTableData() {
      axios.post('/selected-table', {'table_id': this.SelectedTableId}).then(response => {
        if (response.data.success) {
          this.SelectedTable = response.data.result;

          if (this.SelectedTable) {
            if (this.SelectedTable.fields) {
              let modify_record = {};
              for (let x in this.SelectedTable.fields) {
                modify_record[this.SelectedTable.fields[x].name] = {
                  value: null,
                };
              }
              this.modify_record = modify_record;

              let modify_record_error = {};
              for (let x in this.SelectedTable.fields) {
                modify_record_error[this.SelectedTable.fields[x].name] = false;
              }
              this.modify_record_error = modify_record_error;
            }
          }
          // console.log(this.modify_record);

        }
      });
    },
    hasSelectedData(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        return true;
      }

      return false;
    },
    emilFrom(emailFromList) {
      let FromList = {};
      for (let x in emailFromList) {
        if (emailFromList[x].name != 'email_address') {
          FromList[x] = emailFromList[x];
        }
      }
      return FromList;
    },
    removeSelectedItem(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        mappingData.splice(_index, 1);
      }
      if (this.create_record) {
        for (let x in this.create_record) {
          if (x == field.name) {
            this.create_record[x].value = null;
          }
        }
      }

      if (this.modify_record) {
        for (let x in this.modify_record) {
          if (x == field.name) {
            this.modify_record[x].value = null;
          }
        }
      }

      this.buildSelectedLabels();
    },

    hasSelectedDataEmailTask(mappingData, field) {

      if (field == 'from') {
        if (mappingData['from']) {
          return true;
        }
        return false;

      } else if (field == 'recipient') {
        if (mappingData['recipient']) {
          return true;
        }
        return false;

      } else if (field == 'cc') {
        if (mappingData['cc']) {
          return true;
        }
        return false;

      } else if (field == 'category') {
        if (mappingData['category']) {
          return true;
        }
        return false;

      } else if (field == 'responsible') {
        if (mappingData['responsible']) {
          return true;
        }
        return false;
      }
    },
    removeSelectedItemEmail(mappingData, field) {

      mappingData[field] = null;

      if (document.getElementById('mapFieldTaskDD-' + field)) {
        document.getElementById('mapFieldTaskDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }

      if (document.getElementById('mapFieldEmailDD-' + field)) {
        document.getElementById('mapFieldEmailDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }
    },
    fieldTypeOf(FieldType) {

      let isIncludeSelctedField = this.ExceptionFieldType.includes(FieldType.type);

      if (isIncludeSelctedField) {
        return false;
      }

      return true;
    },
    searchSubmit(event) {
      let keyword = event.target.value.toLowerCase();
      $("#filterSearchModal *").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(keyword) > -1);
      });
    },
    checkActiveDD(field) {
      var _index = this.ActiveAccordion.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    modifyAccordion(label) {
      var _index = this.ActiveAccordion.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordion = [];
        this.ActiveAccordion.push(label);
      } else {
        this.ActiveAccordion = [];
      }
    },
    buildSelectedLabels(fields = null) {
      if (!fields) {
        if (this.DropDownSelectedTable_Create && this.DropDownSelectedTable_Create.fields) {
          fields = this.DropDownSelectedTable_Create.fields;
        } else if (this.DropDownSelectedTable_Modify && this.DropDownSelectedTable_Modify.fields) {
          fields = this.DropDownSelectedTable_Modify.fields;
        }
      }
      if (fields) {
        fields.map((field) => {
          this.selectedValues[field.id] = this.InitLabelForCreate(field);
        });
      }
      this.$forceUpdate();
    },
    InitLabelForCreate(field) {

      let _index = this.CreateRecordMapping.findIndex(x => x.mapping_for_id == field.id);
      if (_index > -1) {
        if (this.CreateRecordMapping[_index].record_type == "custom") {

          if (Array.isArray(this.CreateRecordMapping[_index].mapped_with_name)) {
            let val = '';
            for (let i = 0; i < this.CreateRecordMapping[_index].mapped_with_name.length; i++) {
              val += this.CreateRecordMapping[_index].mapped_with_name[i] + ',';
            }
            return val.replace(/,\s*$/, '');
          } else {
            return this.CreateRecordMapping[_index].mapped_with_name;
          }
        } else {

          let _selected_field_index = -1;

          _selected_field_index = this.SelectedTable.fields.findIndex(x => x.id == this.CreateRecordMapping[_index].mapped_with_id);

          if (this.CreateRecordMapping[_index].record_type == "new") {
            if (this.CreateRecordMapping[_index].field_type_dd == 'relationship') {
              _selected_field_index = this.SelectedTableExcludedColumnListReationship.findIndex(x => x.id == this.CreateRecordMapping[_index].mapped_with_id);
              if (_selected_field_index == -1) {
                return this.lang.select + ' ' + this.lang.value;
              }
              return this.SelectedTableExcludedColumnListReationship[_selected_field_index].label;
            }
            return this.SelectedTable.fields[_selected_field_index].label;
          } else if (this.CreateRecordMapping[_index].record_type == "user") {
            if (Array.isArray(this.CreateRecordMapping[_index].mapped_with_name)) {
              let val = '';
              for (let i = 0; i < this.CreateRecordMapping[_index].mapped_with_name.length; i++) {
                val += this.CreateRecordMapping[_index].mapped_with_name[i] + ',';
              }
              return val.replace(/,\s*$/, '');
            } else {
              return this.CreateRecordMapping[_index].mapped_with_name;
            }
          } else {
            if (this.CreateRecordMapping[_index].field_type_dd == 'relationship') {
              _selected_field_index = this.SelectedTableExcludedColumnListReationship.findIndex(x => x.id == this.CreateRecordMapping[_index].mapped_with_id);
              if (_selected_field_index == -1) {
                return this.lang.select + ' ' + this.lang.value;
              }
              return this.lang.old + ' ' + this.lang.record + '.' + this.SelectedTableExcludedColumnListReationship[_selected_field_index].label;
            }
            return this.lang.old + ' ' + this.lang.record + '.' + this.SelectedTable.fields[_selected_field_index].label;
          }
        }

      } else {
        return this.lang.select + ' ' + this.lang.value;
      }
    },
    InitLabelForModify(field) {
      let _index = this.ModifyRecordMapping.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        let _selected_field_index = this.SelectedTable.fields.findIndex(x => x.id == this.ModifyRecordMapping[_index].mapped_with_id);

        if (this.ModifyRecordMapping[_index].record_type == "new") {
          return this.SelectedTable.fields[_selected_field_index].label;
        } else if (this.ModifyRecordMapping[_index].record_type == "old") {
          return this.lang.old + ' ' + this.lang.record + '.' + this.SelectedTable.fields[_selected_field_index].label;
        } else if (this.ModifyRecordMapping[_index].record_type == "custom") {
          if (Array.isArray(this.ModifyRecordMapping[_index].mapped_with_name)) {

            let val = '';
            for (let i = 0; i < this.ModifyRecordMapping[_index].mapped_with_name.length; i++) {
              val += this.ModifyRecordMapping[_index].mapped_with_name[i] + ',';
            }

            return val.replace(/,\s*$/, '');
          } else {
            return this.SelectedTable.fields[_selected_field_index] = this.ModifyRecordMapping[_index].mapped_with_name;
          }

        } else if (this.ModifyRecordMapping[_index].record_type == "user") {
          if (Array.isArray(this.ModifyRecordMapping[_index].mapped_with_name)) {
            let val = '';
            for (let i = 0; i < this.ModifyRecordMapping[_index].mapped_with_name.length; i++) {
              val += this.ModifyRecordMapping[_index].mapped_with_name[i] + ',';
            }
            return this.SelectedTable.fields[_selected_field_index] = val.replace(/,\s*$/, '');
          } else {
            return this.SelectedTable.fields[_selected_field_index] = this.ModifyRecordMapping[_index].mapped_with_name;
          }
        }

      } else {
        return this.lang.select + ' ' + this.lang.value;
      }
    },
    InitLabelForTask(field) {
      if (this.create_task[field.name] == null) {
        return this.lang.select + ' ' + this.lang.value;
      } else {
        console.log(this.create_task[field.name]);
        if (this.create_task[field.name]['record_type'] == 'custom') {
          return this.create_task[field.name]['selected_field']['name'];
        } else if (this.create_task[field.name]['record_type'] == 'old') {
          return 'Old.' + this.create_task[field.name]['selected_field']['label'];
        } else if (this.create_task[field.name]['record_type'] == 'new') {
          return this.create_task[field.name]['selected_field']['label'];
        } else if (this.create_task[field.name]['record_type'] == 'user') {
          return this.create_task[field.name]['selected_field']['name'];
        }
      }
    },
    outside() {
      this.ActiveAccordion = [];
      // this.ModifyRecordMapping = [];
    },
    outside_task() {
      this.ActiveAccordionTask = [];
    },
    checkDD_Task(field) {
      var _index = this.ActiveAccordionTask.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    openTaskAccordion(label) {
      var _index = this.ActiveAccordionTask.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordionTask = [];
        this.ActiveAccordionTask.push(label);
      } else {
        this.ActiveAccordionTask = [];
      }
    },

    outside_create() {
      this.ActiveAccordionCreate = [];
    },
    checkDD_Create(field) {
      var _index = this.ActiveAccordionCreate.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    openCreateAccordion(label) {
      var _index = this.ActiveAccordionCreate.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordionCreate = [];
        this.ActiveAccordionCreate.push(label);
      } else {
        this.ActiveAccordionCreate = [];
      }
    },

    outside_modify() {
      this.ActiveAccordionModify = [];
    },
    checkDD_Modify(field) {
      var _index = this.ActiveAccordionModify.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    openModifyAccordion(label) {
      var _index = this.ActiveAccordionModify.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordionModify = [];
        this.ActiveAccordionModify.push(label);
      } else {
        this.ActiveAccordionModify = [];
      }
    },
    // get data from contact table
    GetContactTableData() {
      axios.post('/contact-table-data').then(response => {
        if (response.data.success) {
          this.ContactTable = response.data.result;
          this.UserTable = response.data.result;
        }
      });
    },

    GetTaskTableData() {
      axios.post('/task-table-fields').then(response => {
        if (response.data.success) {
          this.TaskTable = response.data.data;
        }
      });
    },

    // get all tables apart from selected table
    GetDataApartFromSelectedTable() {
      axios.post('/non-selected-table', {'table_id': this.SelectedTableId}).then(response => {
        if (response.data.success) {
          this.OtherTables = response.data.result;
        }
      });
    },

    RemoveIDValueForTaskAccordion(data) {
      let _index = data.findIndex(x => x.name == 'id');

      if (_index > -1) {
        data.splice(_index, 1);
      }

      return data;
    },

    SelectTableCreate(table) {
      this.DropDownSelectedTable_Create = table;
      this.MapFieldsCreate = table.fields;

      for (let x in table.fields) {
        this.MapValuesCreate[table.fields[x].name] = null;
      }

      if (table.fields) {

        let create_record = {};
        for (let x in table.fields) {
          create_record[table.fields[x].name] = {
            value: null,
          };
        }
        this.create_record = create_record;

        let create_record_error = {};
        for (let x in table.fields) {
          create_record_error[table.fields[x].name] = false;
        }
        this.create_record_error = create_record_error;

        this.buildSelectedLabels(table.fields);
      }

      // primary target changed -> any secondary config is stale
      this.SecondaryCreateTable = null;
      this.SecondaryCreateTable_label = this.lang.select_table;
      this.SecondaryCreateMapping = [];
      this.ActiveAccordionSecondaryCreate = [];
      if (this.showSecondaryCreate) {
        this.LoadSecondaryCreateSource();
      }
    },

    // Fetch the primary target table detail (relationship-excluded columns) to use
    // as the mapping source for the secondary record.
    LoadSecondaryCreateSource() {
      if (!this.DropDownSelectedTable_Create || !this.DropDownSelectedTable_Create.id) {
        return Promise.resolve();
      }
      return axios.post('/selected-table', {'table_id': this.DropDownSelectedTable_Create.id}).then(response => {
        if (response.data.success) {
          this.SecondaryCreateSourceExcluded = response.data.result.SelectedTableExcludedColumnListReationship || [];
        }
      });
    },
    onToggleSecondaryCreate() {
      if (this.showSecondaryCreate) {
        this.LoadSecondaryCreateSource();
      } else {
        this.SecondaryCreateTable = null;
        this.SecondaryCreateTable_label = this.lang.select_table;
        this.SecondaryCreateMapping = [];
        this.ActiveAccordionSecondaryCreate = [];
      }
    },
    searchSubmitSecondaryCreate(event) {
      let keyword = event.target.value.toLowerCase();
      $("#filterSearchModalSecondaryCreate *").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(keyword) > -1);
      });
    },
    SelectSecondaryCreateTable(table) {
      this.SecondaryCreateTable_label = table.label;
      this.SecondaryCreateTable = table;
      this.SecondaryCreateMapping = [];
      this.buildSecondaryCreateLabels(table.fields);
    },
    checkDD_SecondaryCreate(label) {
      return this.ActiveAccordionSecondaryCreate.findIndex(x => x == label) != -1;
    },
    openSecondaryCreateAccordion(label) {
      let _index = this.ActiveAccordionSecondaryCreate.findIndex(x => x == label);
      this.ActiveAccordionSecondaryCreate = _index == -1 ? [label] : [];
    },
    outside_secondary_create() {
      this.ActiveAccordionSecondaryCreate = [];
    },
    buildSecondaryCreateLabels(fields = null) {
      if (!fields) {
        fields = this.SecondaryCreateTable ? this.SecondaryCreateTable.fields : null;
      }
      if (!fields) {
        return;
      }
      fields.map((field) => {
        this.secondaryCreateSelectedValues[field.id] = this.initSecondaryCreateLabel(field);
      });
      this.$forceUpdate();
    },
    initSecondaryCreateLabel(field) {
      let placeholder = this.lang.select + ' ' + this.lang.value;
      let _index = this.SecondaryCreateMapping.findIndex(x => x.mapping_for_id == field.id);
      if (_index == -1) {
        return placeholder;
      }
      let mapping = this.SecondaryCreateMapping[_index];
      if (mapping.record_type == 'custom' || mapping.record_type == 'user') {
        return Array.isArray(mapping.mapped_with_name) ? mapping.mapped_with_name.join(',') : mapping.mapped_with_name;
      }
      // 'new' maps from the primary (just created) record, 'source' from the record that
      // triggered the automation. The field can come from the regular field list OR from
      // the relationship-excluded list (id / assigned_to / relationship columns).
      let source = mapping.record_type == 'source'
        ? (this.SelectedTable && this.SelectedTable.fields ? this.SelectedTable.fields : [])
          .concat(this.SelectedTableExcludedColumnListReationship || [])
        : (this.DropDownSelectedTable_Create && this.DropDownSelectedTable_Create.fields
          ? this.DropDownSelectedTable_Create.fields : [])
          .concat(this.SecondaryCreateSourceExcluded || []);
      let si = source.findIndex(x => x.id == mapping.mapped_with_id);
      return si > -1 ? source[si].label : placeholder;
    },
    removeSecondaryCreateSelectedItem(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);
      if (_index > -1) {
        mappingData.splice(_index, 1);
      }
      this.buildSecondaryCreateLabels();
    },
    SecondaryCreateOptionSelected(data) {
      if (
          data.mapping_for.field_type === 'multiselect' ||
          data.mapping_for.field_type === 'multipleselect' ||
          (data.selected_field && data.selected_field.field_type_dd && data.selected_field.field_type_dd === 'multiselect')
      ) {
        this.ManipulationMultiSelect(this.SecondaryCreateMapping, data);
        this.buildSecondaryCreateLabels();
        return;
      }

      let _index = this.SecondaryCreateMapping.findIndex(x => x.mapping_for_id == data.mapping_for.id);
      if (_index > -1) {
        this.SecondaryCreateMapping.splice(_index, 1);
      }

      let field_type_dd = data.selected_field.field_type_dd != undefined ? data.selected_field.field_type_dd : null;

      if (data.selected_field.name !== undefined) {
        this.SecondaryCreateMapping.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: data.selected_field.id,
          mapped_with_name: data.selected_field.name,
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }

      this.ActiveAccordionSecondaryCreate = [];
      this.buildSecondaryCreateLabels();
    },
    buildSecondaryCreatePayload() {
      if (!this.showSecondaryCreate
        || !this.SecondaryCreateTable || !this.SecondaryCreateTable.id
        || !this.SecondaryCreateMapping || this.SecondaryCreateMapping.length == 0) {
        return null;
      }
      return {
        selected_table: this.SecondaryCreateTable,
        selected_table_mapping: this.SecondaryCreateTable.fields,
        mapping_data: this.SecondaryCreateMapping,
      };
    },

    SelectTableModify(table) {
      this.DropDownSelectedTable_Modify.label = this.SelectedTable.label + this.lang.record;
    },
    SelectMapField(event, field_id, field_dd, field_name = null) {
      if (event == 'create' && field_dd != undefined) {
        this.MapValuesCreate[field_name] = this.SelectedTable.name + "." + field_dd.name;
        document.getElementById('mapFieldCreateDD-' + field_id).value = this.SelectedTable.name + "." + field_dd.label;
      } else if (event == 'task' && field_dd != undefined) {
        if (field_id == 'assigned_to') {
          this.create_task[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'contact_name') {
          this.create_task[field_id] = field_dd.id;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'start_datetime') {
          this.create_task[field_id] = field_dd;
        }

        if (field_id == 'end_datetime') {
          this.create_task[field_id] = field_dd;
        }

        if (field_id == 'person') {
          this.create_task[field_id] = field_dd.id;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'subject') {
          this.create_task[field_id] = field_dd;
        }

        if (field_id == 'category') {
          this.create_task[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }
        if (field_id == 'status') {
          this.create_task[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }

        if (field_id == 'priority') {
          this.create_task[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }

        if (field_id == 'long_description') {
          this.create_task[field_id] = field_dd;
        }

      } else if (event == 'email' && field_dd != undefined) {

        if (field_id == 'from') {
          this.send_email['from'] = field_dd;

          if (field_dd.record_type == 'old') {
            document.getElementById('mapFieldEmailDD-from').value = field_dd.selected_field.label != undefined ? this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.label : this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.name;
          } else {
            document.getElementById('mapFieldEmailDD-from').value = field_dd.selected_field.label != undefined ? field_dd.selected_field.label : (field_dd.selected_field.email ? field_dd.selected_field.email : field_dd.selected_field.name);
          }
        }
        if (field_id == 'recipient') {
          this.send_email['recipient'] = field_dd;

          if (field_dd.record_type == 'old') {
            document.getElementById('mapFieldEmailDD-recipient').value = field_dd.selected_field.label != undefined ? this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.label : this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.name;
          } else {
            document.getElementById('mapFieldEmailDD-recipient').value = field_dd.selected_field.label != undefined ? field_dd.selected_field.label : (field_dd.selected_field.email ? field_dd.selected_field.email : field_dd.selected_field.name);
          }
        }
        if (field_id == 'cc') {
          this.send_email['cc'] = field_dd;

          if (field_dd.record_type == 'old') {
            document.getElementById('mapFieldEmailDD-cc').value = field_dd.selected_field.label != undefined ? this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.label : this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.name;
          } else {
            document.getElementById('mapFieldEmailDD-cc').value = field_dd.selected_field.label != undefined ? field_dd.selected_field.label : (field_dd.selected_field.email ? field_dd.selected_field.email : field_dd.selected_field.name);
          }
        }

        this.outside();
      }

    },

    SaveAction() {

      // for validation

      // add-create-record-has-required
      // add-modify-record-has-required
      // add-task-record-has-required
      // add-send-email-record-has-required

      let _create_record = this.create_record;
      let _modify_record = this.modify_record;
      let _create_task = this.create_task;
      let _send_email = this.send_email;

      let isFindCreate = false;
      let isFindModify = false;
      let isFindTask = false;
      let isFindMail = false;

      let create_flag = 0;
      let modify_flag = 0;
      let task_flag = 0;
      let email_flag = 0;


      if (_create_record) {
        Object.keys(_create_record).forEach(function (key) {
          if (_create_record[key].value != null && _create_record[key].value != "") {
            isFindCreate = true;
          }
        });

        /* for multiselect 24.12.2019 only for contacts table create record*/
        if (this.CreateRecordMapping) {
          const _index = this.CreateRecordMapping.findIndex(x => x.field_type_dd == 'multiselect' || x.field_type_dd == 'multipleselect');
          if (_index > -1) {
            if (this.CreateRecordMapping[_index].mapped_with_name.length > 0) {
              isFindCreate = true;
            }
          }
        }
        /* for multiselect */
      }
      if (_modify_record) {
        Object.keys(_modify_record).forEach(function (key) {
          if (_modify_record[key].value != null && _modify_record[key].value != "") {
            isFindModify = true;
          }
        });

        /* for multiselect 24.12.2019 only for contacts table modify record*/
        if (this.ModifyRecordMapping) {
          const _index = this.ModifyRecordMapping.findIndex(x => x.field_type_dd == 'multiselect' || x.field_type_dd == 'multipleselect');
          if (_index > -1) {
            if (this.ModifyRecordMapping[_index].mapped_with_name.length > 0) {
              isFindModify = true;
            }
          }
        }
        /* for multiselect */
      }
      Object.keys(_create_task).forEach(function (key) {
        if (_create_task[key] != null && _create_task[key] != "") {
          isFindTask = true;
        }
      });
      Object.keys(_send_email).forEach(function (key) {
        if (_send_email[key] != null && _send_email[key] != "") {
          isFindMail = true;
        }
      });

      for (let error in this.create_record) {
        this.create_record_error[error] = false;
      }
      document.querySelector('#add-create-record-has-required').parentElement.classList.remove('error-action-creation');
      document.querySelector('#add-create-record-has-required').style.display = 'none';

      for (let error in this.modify_record) {
        this.modify_record_error[error] = false;
      }
      document.querySelector('#add-modify-record-has-required').parentElement.classList.remove('error-action-creation');
      document.querySelector('#add-modify-record-has-required').style.display = 'none';

      if (isFindTask) {

        for (let error in this.create_task) {
          // check the field is required or not
          let is_required = false;

          if ((!this.create_task[error] || this.create_task[error] == "") && is_required) {
            this.create_task_error[error] = true;
            task_flag = 1;

            var field = null;

            /** For Language Support */
            // if(error == 'due_date'){
            //     field = this.lang['when_is_it_due'];
            // }else if(error == 'responsible'){
            //     field = this.lang['task_responsible'];
            // }else{
            //     field = this.lang[error];
            // }

            field = error;
            document.querySelector('#add-task-record-has-required').parentElement.classList.add('error-action-creation');
            document.querySelector('#add-task-record-has-required').style.display =
                'inline-block';
            // this.$awn.alert(this.lang.required+' '+field+' '+this.lang.field_not_set,{
            //     labels : {
            //       alert: this.lang.failed,
            //     }
            // });

            toastr.error(this.lang.required + ' ' + field + ' ' + this.lang.field_not_set, this.lang.failed);

            return false;
          } else {
            document.querySelector('#add-task-record-has-required').parentElement.classList.remove('error-action-creation');
            document.querySelector('#add-task-record-has-required').style.display = 'none';
            this.create_task_error[error] = false;
          }
        }

      } else {
        for (let error in this.create_task) {
          this.create_task_error[error] = false;
        }
        document.querySelector('#add-task-record-has-required').parentElement.classList.remove('error-action-creation');
        document.querySelector('#add-task-record-has-required').style.display = 'none';
      }

      if (isFindMail) {
        let skipFields = ['cc', 'files', 'attachedPdfs', 'xmlList'];
        for (let error in this.send_email) {
          if (!skipFields.includes(error)) {
            if (!this.send_email[error] || this.send_email[error] == "") {
              this.send_email_error[error] = true;
              email_flag = 1;
              document.querySelector('#add-send-email-record-has-required').parentElement.classList.add('error-action-creation');
              document.querySelector('#add-send-email-record-has-required').style.display =
                  'inline-block';

              toastr.error(this.lang.required + ' ' + this.lang[error] + ' ' + this.lang.field_not_set, this.lang.failed);

              return false;
            } else {
              document.querySelector('#add-send-email-record-has-required').parentElement.classList.remove('error-action-creation');
              document.querySelector('#add-send-email-record-has-required').style.display =
                  'none';
              this.send_email_error[error] = false;
            }
          }
        }
      } else {
        for (let error in this.send_email) {
          this.send_email_error[error] = false;
        }
        document.querySelector('#add-send-email-record-has-required').parentElement.classList.remove('error-action-creation');
        document.querySelector('#add-send-email-record-has-required').style.display = 'none';
      }

      if ((create_flag == 0) && (modify_flag == 0) && (task_flag == 0) && (email_flag == 0)) {
        for (let error in this.create_record) {
          this.create_record_error[error] = false;
          this.create_record[error].value = null;
        }
        for (let error in this.modify_record) {
          this.modify_record_error[error] = false;
          this.modify_record[error].value = null;
        }
        for (let error in this.create_task) {
          this.create_task_error[error] = false;
        }
        for (let error in this.send_email) {
          this.send_email_error[error] = false;
        }
        this.SaveActionAfterValidation();
      }

    },

    requiredFieldToScroll(divClass, action, field_label) {

      // this.$awn.alert(this.lang.required+' '+field_label+' '+this.lang.field_not_set,{
      //     labels : {
      //       alert: this.lang.failed,
      //     }
      // });

      toastr.error(this.lang.required + ' ' + field_label + ' ' + this.lang.field_not_set, this.lang.failed);

      var focusOnDiv = document.querySelector('#add-action-modal .modal-body #add-' + action + '-record .workflow-map-fields-container .' + action + '-record-' + divClass);

      focusOnDiv.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    },
    SaveActionAfterValidation() {
      this.action_details = {
        create_record: null,
        modify_record: null,
        create_task: null,
        send_email: null
      };

      if (this.CreateRecordMapping.length > 0) {

        this.action_details.create_record = {
          selected_table: this.DropDownSelectedTable_Create,
          selected_table_mapping: this.MapFieldsCreate,
          mapping_data: this.CreateRecordMapping,
          secondary_create_record: this.buildSecondaryCreatePayload(),
          level: this.level,
        };
      }

      this.action_details.modify_record = {
        selected_table: this.SelectedTable,
        // selected_table_mapping: this.MapFieldsModify,
        mapping_data: this.ModifyRecordMapping,
        level: this.level,
      };

      // create task data
      this.action_details.create_task = {
        create_task: {
          subject: this.create_task.subject,
          start_datetime: this.create_task.start_datetime,
          end_datetime: this.create_task.end_datetime,
          category: this.create_task.category,
          status: this.create_task.status,
          assigned_to: this.create_task.assigned_to,
          priority: this.create_task.priority,
          contact_name: this.create_task.contact_name,
          person: this.create_task.person,
          long_description: this.create_task.long_description,

        },
        level: this.level,
      };

      // send email data
      this.action_details.send_email = {
        send_email: {
          content: this.send_email.content,
          from: this.send_email.from,
          recipient: this.send_email.recipient,
          cc: this.send_email.cc,
          subject: this.send_email.subject,
          files: [],
          attachedPdfs: this.selectedPdfList,
          xmlList: this.xmlList
        },
        level: this.level,
      };

      $('#add-action-modal').modal('hide');


      let formData = new FormData();
      var files = this.$refs.dropzone.getQueuedFiles();
      var files_name_array = null;

      if (files.length > 0) {

        for (var i = 0; i < files.length; i++) {
          const file = files[i];
          formData.append('files[' + i + ']', file);
        }

        /*Upload In temp folder In attachments start*/

        axios.post('/upload-attachments-temp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          files_name_array = response.data;
          this.action_details.send_email.send_email.files = files_name_array;
          this.$emit('saveActionEvent', this.action_details);
        });
      } else {
        this.$emit('saveActionEvent', this.action_details);
      }

      this.$refs.dropzone.removeAllFiles();
      this.renderingPdfList = [];
      this.selectedPdfList = [];

      /*Upload In temp folder In attachments end*/

      // reset the form
      this.reset();
    },

    reset() {
      // reset the create form
      this.MapFieldsCreate = null;
      this.DropDownSelectedTable_Create.label = this.lang.select + ' ' + this.lang.table;
      this.GetDataApartFromSelectedTable();

      // reset email value
      this.send_email = {
        from: null,
        recipient: null,
        subject: null,
        content: ''
      }

      document.getElementById('mapFieldEmailDD-' + 'from').value = this.lang.select + ' ' + this.lang.value;
      document.getElementById('mapFieldEmailDD-' + 'recipient').value = this.lang.select + ' ' + this.lang.value;

      // reset task value
      this.create_task = {
        assigned_to: null,
        subject: null,
        contact_name: null,
        start_datetime: null,
        end_datetime: null,
        person: null,
        category: null,
        status: null,
        priority: null,
        long_description: null,
      };

      for (let i = 0; i < this.TaskTable.length; i++) {
        if (this.TaskTable[i].field_type == 'select' || this.TaskTable[i].field_type == 'relationship') {
          document.getElementById('mapFieldTaskDD-' + this.TaskTable[i].name).value = this.lang.select + ' ' + this.lang.value;
        }
      }

      this.CreateRecordMapping = [];
      this.ModifyRecordMapping = [];

      this.showSecondaryCreate = false;
      this.SecondaryCreateTable = null;
      this.SecondaryCreateTable_label = this.lang.select_table;
      this.SecondaryCreateMapping = [];
      this.ActiveAccordionSecondaryCreate = [];
      this.SecondaryCreateSourceExcluded = [];
    },

    hasValueSelectedTask(name) {
      if (this.create_task[name] != null) {
        return true;
      }

      return false;
    },

    removeSelectedValue(name) {
      this.create_task[name] = null;

      // reset the field
      document.getElementById('mapFieldTaskDD-' + name).value = this.lang.select + ' ' + this.lang.value;
    },

    TaskRecordOptionSelected(data) {
      let _value = {
        'mapping_for': data['mapping_for']['name'],
        'record_type': data['record_type'],
        'selected_field': data['selected_field'],
        'label': data['selected_field']['label']
      };

      this.create_task[data['mapping_for']['name']] = _value;
      this.outside_task();
    },

    CreateRecordOptionSelected(data) {

      // remove the old value if exists

      if (
          data.mapping_for.field_type === 'multiselect' ||
          data.mapping_for.field_type === 'multipleselect' ||
          (data.selected_field && data.selected_field.field_type_dd && data.selected_field.field_type_dd === 'multiselect')
      ) {
        this.ManipulationMultiSelect(this.CreateRecordMapping, data);
        this.buildSelectedLabels()
        return;
      } else {
        let _index = this.CreateRecordMapping.findIndex(x =>
            x.mapping_for_id == data.mapping_for.id
        );
        if (_index > -1) {
          this.CreateRecordMapping.splice(_index, 1);
        }
      }

      for (let x in this.create_record) {
        if (x == data.mapping_for.name) {
          this.create_record[x].value = data.selected_field.name;
        }
      }


      let field_type_dd = null;

      if (data.selected_field.field_type_dd != undefined) {
        field_type_dd = data.selected_field.field_type_dd;
      }

      if (data.selected_field.name) {
        this.CreateRecordMapping.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: data.selected_field.id,
          mapped_with_name: data.selected_field.name,
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }

      this.ActiveAccordionCreate = [];
      this.buildSelectedLabels()
    },

    ModifyRecordOptionSelected(data) {
      // remove the old value if exists
      // console.log(data);

      if (
          data.mapping_for.field_type === 'multiselect' ||
          data.mapping_for.field_type === 'multipleselect' ||
          (data.selected_field && data.selected_field.field_type_dd && data.selected_field.field_type_dd === 'multiselect')
      ) {
        this.ManipulationMultiSelect(this.ModifyRecordMapping, data);
        this.buildSelectedLabels()
        return;
      } else {
        let _index = this.ModifyRecordMapping.findIndex(x =>
            x.mapping_for_id == data.mapping_for.id
        );
        if (_index > -1) {
          this.ModifyRecordMapping.splice(_index, 1);
        }
      }

      for (let x in this.modify_record) {
        if (x == data.mapping_for.name) {
          this.modify_record[x].value = data.selected_field.name;
        }
      }

      let field_type_dd = null;

      if (data.selected_field.field_type_dd != undefined) {
        field_type_dd = data.selected_field.field_type_dd;
      }

      if (data.selected_field.name) {
        this.ModifyRecordMapping.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: data.selected_field.id,
          mapped_with_name: data.selected_field.name,
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }

      this.ActiveAccordionModify = [];
      this.buildSelectedLabels()
    },
    ManipulationMultiSelect(RecordMapping, data) {

      let outer_index = RecordMapping.findIndex(x =>
          x.mapping_for_id == data.mapping_for.id
      );

      if (outer_index > -1) {

        let inner_index = RecordMapping[outer_index].mapped_with_name.indexOf(data.selected_field.name);

        if (inner_index > -1) {
          RecordMapping[outer_index].mapped_with_name.splice(inner_index, 1);
          RecordMapping[outer_index].mapped_with_id.splice(inner_index, 1);

          if (RecordMapping[outer_index].mapped_with_name.length == 0) {
            RecordMapping.splice(outer_index, 1);
          }

        } else {
          RecordMapping[outer_index].mapped_with_name.push(data.selected_field.name);
          RecordMapping[outer_index].mapped_with_id.push(data.selected_field.id);
        }

      } else {

        let field_type_dd = null;

        if (data.selected_field.field_type_dd != undefined) {
          field_type_dd = data.selected_field.field_type_dd;
        }

        RecordMapping.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: [data.selected_field.id],
          mapped_with_name: [data.selected_field.name],
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }
    },
    setDynamicFormat() {
      switch (this.Auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setDateSeparator(format) {
      if (this.Auth.formatting.date_separator) {
        let _separator = this.Auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    }
  }
}
</script>
